<template>
  <CustomerDetailPlaceholderTab title="Notas simples" />
</template>

<script>
import CustomerDetailPlaceholderTab from './CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailSimpleNotesTab',
  components: { CustomerDetailPlaceholderTab },
};
</script>
